export default class AbstractNode {
    get type() {
        return "node";
    }

    get schema() {
        return {}
    }

    get markdownToken() {
        return "";
    }

    toMarkdown(state, node) {
    }

    get parseMarkdown() {
        return {};
    }

    inputRules({type}) {
        return [];
    }

    keys({type}) {
        return {};
    }

    commands({schema}) {
        return {}
    }
}